<template>
  <b-container
    fluid
    class="sneaker-legacy"
    ref="sneakerLegacy"
    @mouseenter="pauseCarousel"
    @mouseleave="playCarousel"
  >
    <b-carousel id="carousel-fade" indicators v-model="carouselSlide" :interval="carouselInterval">
      <b-carousel-slide>
        <b-row>
          <b-col>
            <div class="sneaker-container">
              <img
                src="@/assets/rebrand/home/sneaker-legacy.png"
                alt="sneaker legacy"
                class="title-sneaker-legacy -wb"
              />

              <h1 class="title-legacy -mb">Build your own</h1>
              <img
                src="@/assets/mobile/txt-sneaker-legacy.png"
                alt="sneaker legacy"
                class="title-sneaker-legacy -mb"
              />
              <b-row>
                <b-col md="4">
                  <img
                    src="@/assets/mobile/txt-create.png"
                    alt="sneaker legacy"
                    class="txt-shape-create -mb"
                  />
                  <p class="desc-legacy">
                    <img
                      src="@/assets/mobile/legacy-shape-5.png"
                      alt="legacy shape"
                      class="legacy-shape5 -mb"
                    />
                    <img
                      src="@/assets/mobile/legacy-shape-6.png"
                      alt="legacy shape"
                      class="legacy-shape6 -mb"
                    />
                    <img
                      src="@/assets/mobile/legacy-shape-7.png"
                      alt="legacy shape"
                      class="legacy-shape7 -mb"
                    />
                    <img
                      src="@/assets/mobile/legacy-shape-8.png"
                      alt="legacy shape"
                      class="legacy-shape8 -mb"
                    />
                    <img
                      src="@/assets/mobile/legacy-shape-15.png"
                      alt="legacy shape"
                      class="legacy-shape16 -mb"
                    />
                    Showcase your kicks by minting DED Stock <br />
                    <span class="emp">Digitally Enabled Dopeness </span>
                    the first digital collectible made <br />for sneakers.
                  </p>
                  <b-button class="btn-learn-more"></b-button>
                </b-col>
                <b-col md="8">
                  <img
                    src="@/assets/mobile/legacy-web-shape.png"
                    alt="legacy shape"
                    class="legacy-shape9 -mb"
                  />
                  <img
                    src="@/assets/mobile/legacy-shape-shoe.png"
                    alt="legacy shape"
                    class="legacy-shape10 -mb"
                  />
                  <img
                    src="@/assets/mobile/legacy-shape-11.png"
                    alt="legacy shape"
                    class="legacy-shape11 -mb"
                  />
                  <img
                    src="@/assets/mobile/legacy-shape-12.png"
                    alt="legacy shape"
                    class="legacy-shape12 -mb"
                  />
                  <img
                    src="@/assets/mobile/legacy-shape-13.png"
                    alt="legacy shape"
                    class="legacy-shape13 -mb"
                  />
                  <img
                    src="@/assets/mobile/legacy-shape-14.png"
                    alt="legacy shape"
                    class="legacy-shape14 -mb"
                  />

                  <b-card-group class="-wb">
                    <b-card :img-src="sneaker1" img-alt="Image" img-top>
                      <b-card-text> <b>1.</b> Sneaker </b-card-text>
                    </b-card>

                    <b-card :img-src="dedstockcreator" img-alt="Image" img-top>
                      <b-card-text> <b>2.</b> DED Stock Creator </b-card-text>
                    </b-card>

                    <b-card :img-src="dedstock" img-alt="Image" img-top>
                      <b-card-text> <b>3.</b> Ded Stock </b-card-text>
                    </b-card>
                  </b-card-group>
                </b-col>
              </b-row>
              <b-row class="-mb">
                <b-col md="8">
                  <div class="create-title-mob">
                    <p>
                      <span class="number">1</span>
                      <span>Sneaker</span>
                    </p>
                    <p>
                      <span class="number">2</span>
                      <span>Ded Stock Creator</span>
                    </p>
                    <p>
                      <span class="number">3</span>
                      <span>Ded Stock</span>
                    </p>
                  </div>
                </b-col>
              </b-row>
            </div>
          </b-col>
        </b-row>
        <img
          src="@/assets/mobile/legacy-shape-1.png"
          alt="legacy shape"
          class="legacy-shape1 -mb"
        />
        <img
          src="@/assets/mobile/legacy-shape-2.png"
          alt="legacy shape"
          class="legacy-shape2 -mb"
        />
        <img
          src="@/assets/mobile/legacy-shape-3.png"
          alt="legacy shape"
          class="legacy-shape3 -mb"
        />
        <img
          src="@/assets/mobile/legacy-shape-4.png"
          alt="legacy shape"
          class="legacy-shape4 -mb"
        />
        <img
          src="@/assets/rebrand/home/create-overlay2.png"
          alt="sneaker create"
          class="sneaker-overlay -wb"
        />
        <img src="@/assets/mobile/legacy-glow.png" alt="legacy shape" class="legacy-shape15 -mb" />
        <img
          src="@/assets/rebrand/home/sneaker-create.png"
          alt="sneaker create"
          class="sneaker-create -wb"
        />
        <img
          src="@/assets/rebrand/home/create-desc.png"
          alt="sneaker create"
          class="img-create-desc -wb"
        />
      </b-carousel-slide>
      <b-carousel-slide>
        <b-row>
          <b-col>
            <div class="sneaker-container">
              <img
                src="@/assets/rebrand/home/sneaker-legacy.png"
                alt="sneaker legacy"
                class="title-sneaker-legacy -wb"
              />

              <h1 class="title-legacy -mb">Build your own</h1>
              <img
                src="@/assets/mobile/txt-sneaker-legacy.png"
                alt="sneaker legacy"
                class="title-sneaker-legacy -mb"
              />

              <b-row>
                <b-col md="4">
                  <img
                    src="@/assets/mobile/legacy-shape-17.png"
                    alt="sneaker legacy"
                    class="legacy-shape17 -mb"
                  />
                  <img
                    src="@/assets/mobile/txt-collect.png"
                    alt="sneaker legacy"
                    class="txt-shape-collect -mb"
                  />
                  <p class="collect-legacy">
                    Collect DED Stock and digital drops, <br />
                    as well as earn rewards and tokens <br />
                    to level up your status.
                    <img
                      src="@/assets/mobile/legacy-border.png"
                      alt="sneaker legacy"
                      class="legacy-border -mb"
                    />

                    <img
                      src="@/assets/mobile/legacy-shape-18.png"
                      alt="sneaker legacy"
                      class="legacy-shape18 -mb"
                    />
                    <img
                      src="@/assets/mobile/legacy-shape-19.png"
                      alt="sneaker legacy"
                      class="legacy-shape19 -mb"
                    />
                  </p>
                </b-col>
                <b-col md="8">
                  <img
                    src="@/assets/rebrand/home/over-the-city-soldier.png"
                    alt="over the city soldier"
                    class="city-soldier -wb"
                  />
                  <img
                    src="@/assets/mobile/over-the-city-soldier.png"
                    alt="over the city soldier"
                    class="city-soldier -mb"
                  />
                </b-col>
              </b-row>
            </div>
          </b-col>
        </b-row>
        <img
          src="@/assets/mobile/legacy-shape-4.png"
          alt="legacy shape"
          class="legacy-shape4 -mb"
        />
        <img
          src="@/assets/rebrand/home/collect-shape-1.png"
          alt="sneaker collect"
          class="collect-shape1 -wb"
        />
        <img
          src="@/assets/rebrand/home/collect-shape-2.png"
          alt="sneaker collect"
          class="collect-shape2 -wb"
        />
        <img
          src="@/assets/rebrand/home/sneaker-collect.png"
          alt="sneaker collect"
          class="sneaker-collect -wb"
        />
        <img
          src="@/assets/rebrand/home/collect-desc.png"
          alt="sneaker collect"
          class="img-collect-desc -wb"
        />
        <img
          src="@/assets/mobile/collect-overlay.png"
          alt="over the city soldier"
          class="collect-overlay -mb"
        />
      </b-carousel-slide>
      <b-carousel-slide>
        <b-row>
          <b-col>
            <div class="sneaker-container">
              <img
                src="@/assets/rebrand/home/sneaker-legacy.png"
                alt="sneaker legacy"
                class="title-sneaker-legacy -wb"
              />
              <h1 class="title-legacy -mb">Build your own</h1>
              <img
                src="@/assets/mobile/txt-sneaker-legacy.png"
                alt="sneaker legacy"
                class="title-sneaker-legacy -mb"
              />
              <b-row>
                <b-col md="5">
                  <img
                    src="@/assets/mobile/legacy-shape-17.png"
                    alt="sneaker legacy"
                    class="legacy-shape17 -mb"
                  />
                  <img
                    src="@/assets/mobile/compete.png"
                    alt="sneaker legacy"
                    class="txt-shape-combat -mb"
                  />
                  <p class="combat-legacy -wb">
                    Compete your personal collection in turn-based <br />
                    style bot-to-bot battles against evil code bots, <br />
                    your friends, and other sneakerheads worldwide.
                  </p>
                  <p class="combat-legacy -mb">
                    Compete your personal collection in<br />
                    turn-based style bot-to-bot battles<br />
                    against evil code bots, your friends,<br />
                    and other sneakerheads worldwide.
                  </p>
                  <img
                    src="@/assets/mobile/legacy-shape-20.png"
                    alt="sneaker legacy"
                    class="legacy-shape20 -mb"
                  />
                  <img
                    src="@/assets/mobile/legacy-shape-18.png"
                    alt="sneaker legacy"
                    class="legacy-shape18 -mb"
                  />
                  <img
                    src="@/assets/mobile/legacy-shape-19.png"
                    alt="sneaker legacy"
                    class="legacy-shape19 -mb"
                  />
                </b-col>
                <b-col md="7">
                  <img src="@/assets/mobile/combat-shoe.png" alt="shoes" class="create-shoe -mb" />
                  <img src="@/assets/rebrand/home/shoes.png" alt="shoes" class="create-shoe -wb" />
                </b-col>
              </b-row>
            </div>
          </b-col>
        </b-row>
        <img
          src="@/assets/mobile/legacy-shape-4.png"
          alt="legacy shape"
          class="legacy-shape4 -mb"
        />
        <img
          src="@/assets/mobile/overlay-combat.png"
          alt="legacy shape"
          class="legacy-shape21 -mb"
        />
        <img
          src="@/assets/rebrand/home/sneaker-combat.png"
          alt="sneaker Compete"
          class="sneaker-combat -wb"
        />
        <img
          src="@/assets/rebrand/home/combat-desc.png"
          alt="sneaker Compete"
          class="img-combat-desc -wb"
        />
      </b-carousel-slide>
    </b-carousel>
  </b-container>
</template>
<script>
export default {
  name: 'SneakerLegacy',
  data() {
    return {
      sneaker1: require('../../assets/rebrand/home/sneaker1.png'),
      dedstockcreator: require('../../assets/rebrand/home/ded-stock-creator1.png'),
      dedstock: require('../../assets/rebrand/home/ded-stock1.png'),
      carouselSlide: null,
      carouselInterval: 9000,
    };
  },
  methods: {
    pauseCarousel() {
      this.carouselInterval = 0;
    },
    playCarousel() {
      this.carouselInterval = 9000;
    },
  },
  mounted() {
    this.$store.commit('setSneakerLegacyRef', this.$refs.sneakerLegacy);
  },
  watch: {
    '$store.getters.getSneakerLegacySlide': function () {
      this.carouselSlide = this.$store.getters.getSneakerLegacySlide;
      this.carouselInterval = 0;
    },
  },
};
</script>
